import { __spreadValues } from "./chunk.Z4XV3SMG.js";

// src/components/input/strategies.ts
var nativeNumericStrategy = {
  autoClamp: false,
  noStepAlign: false,
  noStepValidation: false
};
var modernNumericStrategy = {
  autoClamp: true,
  noStepAlign: true,
  noStepValidation: true
};
var createNumericStrategy = (settings = {}) => __spreadValues(__spreadValues({}, nativeNumericStrategy), settings);
export { nativeNumericStrategy, modernNumericStrategy, createNumericStrategy };
